<script setup lang="ts">
useHead({
  meta: [
    {
      name: 'description',
      content: 'Miss W - Feature Live Streaming',
    },
  ],
})
</script>

<template>
  <div w-full overflow-x-hidden>
    <LiveSection1 />

    <div class="wrapper" min-h-1000px>
      <LiveSection2 />
      <LiveSection3 mt-40px lg:mt-80px />
      <LiveSection4 mt-40px lg:mt-120px />
      <LiveSection5 mt-40px lg:mt-120px />
    </div>

    <IntroductionSponsors class="!lt-lg:pt-75px" />
  </div>
</template>

<style scoped>
.wrapper {
  background: linear-gradient(180deg, #460008 15.58%, #000);
}
</style>
